/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useGetVehicleInfo } from "../../../queries/useGetVehicleInfo";
import { Pagination } from "../../../ui/Pagination/Pagination";
import { Section } from "../../../ui/Section/Section";
import { NoData } from "../../NoData/NoData";
import { ContactLeadForm } from "../../ProductDetails/Common/LeadForm/ContactLeadForm";
import { useTireCompareIds } from "../TiresCompareDialog/useTireCompareIds";
import { StockLevelsModal } from "./StockLevelsModal/StockLevelsModal";
import { TireTile } from "./Tile/TireTile";
import { useTireResults } from "./useTireResults";

const placeholder = {
  filteredParts: [null, null, null, null, null, null],
  metatagList: null,
  resultParameters: null,
};

export const TireList: FunctionComponent = () => {
  const { data = placeholder } = useTireResults();
  const { t } = useTranslation();
  const { data: vehicleInfo } = useGetVehicleInfo();
  const [compareIds] = useTireCompareIds();

  if (data === null) {
    return (
      <>
        <Section className="mb-2 md:mb-4 lg:mb-6 p-4 md:p-8 font-bold">
          {t("searchResults.pricingIsNotAvailable")}
        </Section>
        <Section className="max-w-lg mx-auto bg-paper">
          <ContactLeadForm allowPricing={false} part={null} />
        </Section>
      </>
    );
  }

  return (
    <section className="tw-tire-list">
      <Pagination className="sm:col-span-2 xl:col-span-3">
        {data.filteredParts.map((product, key) => {
          return (
            <TireTile
              isCheckedForCompare={compareIds.includes(
                product?.partDetails?.primaryPart?.itemId || ""
              )}
              index={key}
              key={product?.partDetails?.primaryPart?.itemId || key}
              metatagList={data.metatagList}
              part={product}
              resultParameters={data.resultParameters}
              vehicleInfo={vehicleInfo || null}
            />
          );
        })}
      </Pagination>
      {data.filteredParts.length === 0 && (
        <NoData className="col-span-3">{t("searchResults.noData")}</NoData>
      )}
      <StockLevelsModal />
    </section>
  );
};
